import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const Assignments = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div></div>
                <img className='MainContentFixBottomLine' src={Image.inner_pages_bg2} alt='banner'/>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_assignment} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">Assignment</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{verticalAlign: 'middle',display: 'table-cell'}}>
                            <p >
                                <span  >For different learning modes and different Schools, the settings of and procedures for assignment submission may vary. Please refer to the table below for a summary: 
                                </span>
                            </p>
                            <table className={'assignmentTable'} border={1} cellspacing={0} cellpadding={0} style={{'border-collapse':'collapse','border':'none'}}>

                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-top':'solid windowtext 1.0pt',}} rowSpan={'2'}>
                                    <p >
                                    <span  >Assignment files 
                                    </span>
                                    </p>
                                </td>
                                
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >F2F 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-top':'solid windowtext 1.0pt','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p >
                                    <span  >Uploaded by lecturers <b >
                                        
                                        </b>
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none',}}>
                                    <p align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >DL 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p >
                                    <span  >Uploaded by ALTO <br/>
                                    </span>
                                    <span >(For ALTO to upload&nbsp;assignment files, it is essential that instructors submit assessment parameters to SAS(REG) beforehand.)</span>
                                    <span  >
                                        
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-top':'none',}} rowSpan={'2'}>
                                    <p >
                                    <span  >Allowing application and grant of assignment submission extension 
                                    </span>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >F2F 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}} >
                                    <p >
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none',}}>
                                    <p align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >DL 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}} >
                                    <p >
                                    <b >
                                        <span >&#10003; <br/>
                                        </span>
                                    </b>
                                    <span >(Online extension application is not allowed for the last assignment.)</span>
                                    <span  >
                                        
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-top':'none',}} rowSpan={'2'}>
                                    <p >
                                    <span  >Allowing assignment resubmission </span>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >F2F 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p >
                                    <span  >A&amp;SS, B&amp;A — once before due date <br/> E&amp;L, N&amp;HS, S&amp;T — multiple times one day before due date. 
                                    </span>
                                    </p>
                                    <p >
                                    <span  >
                                        <span >&nbsp;</span>
                                        <br/>
                                    </span>
                                    <span >Lecturers are responsible for uploading the assignment files and configuring the settings for each assignment. For multiple submission, there are two</span>
                                    <span > options: 
                                    </span>
                                    </p>
                                    <ul style={{'listStyleType': 'disc', 'paddingLeft': '1.5em'}}>
                                        <li>
                                            <p  >
                                            
                                            <span >Not allowed 
                                            </span>
                                            </p>
                                        </li>
                                        <li>
                                            <p  >
                                            
                                            <span >Allowed only once before the due date (A&amp;SS, B&amp;A) / One day before due date (E&amp;L, N&amp;HS, S&amp;T)</span>
                                            </p>
                                        </li>
                                    </ul>
                                    <p >
                                    
                                    </p>
                                    <p >
                                    <span >Choose the option based on your School’s policy.</span>
                                    </p>
                                    <p >
                                    <span >
                                        
                                    <a href={Image.Word.image037} data-lightbox="AssignmentTableImage" >
                                        <img className='AssignmentTableImage' border={0}  height={'auto'} src={Image.Word.image037}/>
                                        </a>
                                        
                                    </span>
                                    </p>
                                    <p >
                                    
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none',}}>
                                    <p align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >DL 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'solid windowtext 1.0pt','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p >
                                    <span  >A&amp;SS, B&amp;A — once before due date <br/> E&amp;L, N&amp;HS, S&amp;T — multiple times one day before due date 
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt','border-top':'none',}} rowSpan={'2'}>
                                    <p >
                                    <span  >Lecturers/CCs to submit assignment scores 
                                    </span>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >F2F 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <span  >OLE, SAS 
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none',}}>
                                    <p align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >DL 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <span  >OLE 
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt','border-top':'none',}} rowSpan={'2'}>
                                    <p >
                                    <span  >Cut-off time 
                                    </span>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >F2F 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <span  >17:00 
                                    </span>
                                    </p>
                                </td>
                                </tr>
                                <tr >
                                <td  valign={'top'} style={{'border':'solid windowtext 1.0pt','border-left':'none',}}>
                                    <p align={'center'} style={{'textAlign':'center'}}>
                                    <b >
                                        <span  >DL 
                                        </span>
                                    </b>
                                    </p>
                                </td>
                                <td  valign={'top'} style={{'border-top':'none','border-left':'none','border-bottom':'solid windowtext 1.0pt','border-right':'solid windowtext 1.0pt',}}>
                                    <p  align={'center'} style={{'textAlign':'center'}}>
                                    <span  >00:00 
                                    </span>
                                    </p>
                                </td>
                                </tr>
                            </table>
                                <br/><br/>
                            <b>
                                
                                <span className='subtitle' >Turnitin</span>
                                
                                <span  >
                                
                                </span>
                            </b>
                            <p >
                                <span  >Turnitin is a plagiarism detection tool that is used in all courses to check for plagiarism in student assignments. 
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <span  >You can download students’ files from Turnitin or the OLE, but please note that there may be a delay of several hours before the files are available on the OLE. 
                                </span>
                            </p>
                            <p >
                                <span  >
                                <br/> For courses with multiple submission enabled, students’ files will be available on the OLE after the assignment’s final due date. 
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <span >
                                
                                <a href={Image.Word.image039} data-lightbox="image039">
                                <img border={0} width={740} height={'auto'} src={Image.Word.image039}/>
                                </a>
                                
                                </span>
                                <span >
                                <span >&nbsp;</span>
                                <span >
                                    
                                </span>
                                </span>
                            </p>
                            <p >
                                <span >
                                
                                <a href={Image.Word.image041} data-lightbox="image041" >
                                <img border={0} width={700} height={'auto'} src={Image.Word.image041}/>
                                </a>
                                </span>
                                <span >
                                
                                </span>
                            </p>
                            <p >
                                <span  >When configuring the assignment settings, you will encounter a Turnitin setting that offers three options. Choose one according to your School’s policy. 
                                </span>
                            </p>
                            <p >
                                <span >
                                <a href={Image.Word.image043} data-lightbox="image043" >
                                <img border={0} width={500} height={'auto'} src={Image.Word.image043}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <span  >Turnitin has recently released an AI writing detection tool to identify contents written by AI. However, it is important to note that while suspicious sentences will be highlighted, the original sources will not be identified. Teaching staff are advised to review the assignments thoroughly to ensure that students have not used AI to finish their assignments. 
                                </span>
                            </p>
                                <br/><br/>
                            <b>
                                
                                <span className={'subtitle'} >Marking</span>
                                
                                <span  >
                                
                                </span>
                            </b>
                            <p >
                                <span  >The marking of students’ assignments can be done individually or in batches using the following procedures: 
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >Step 1: Download students’ submissions <br/>
                                </span>
                                </b>
                                <span  >For courses with multiple submission enabled, students’ files will only be available on the OLE after the assignment’s final due date. If multiple submission is disabled, students’ files will be available immediately after submission. 
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >
                                    
                                </span>
                                </b>
                            </p>
                            <p  >
                               
                                <span  >On the assignment submission page, click the‘Tools’ tab. <br/>
                                </span>
                                <span >
                                
                                <a href={Image.Word.image044} data-lightbox="image044" >
                                <img border={0} width={500} height={'auto'} src={Image.Word.image044}/>
                                </a>
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Select ‘Zip/Download Attachments’ from the first pull-down list and select the assignment code and tutorial group. <br/>
                                </span>
                                <span >
                                
                                <a href={Image.Word.image047} data-lightbox="image047" >
                                <img border={0} width={250} height={'auto'} src={Image.Word.image047}/>
                                </a>
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Check ‘Append‘_marked’ to all attachments’ so that you will not have to rename the files manually. 
                                </span>
                            </p>
                            <p >
                                <span >
                               
                                <a href={Image.Word.image049} data-lightbox="image049">
                                <img border={0} width={280} height={'auto'} src={Image.Word.image049}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Click the ‘Zip &amp; Download’ button and a zip file containing all students’ submissions will be downloaded to your computer. <br/>
                                </span>
                                <span >
                                <a href={Image.Word.image051} data-lightbox="image051">                                
                                <img border={0} width={280} height={'auto'} src={Image.Word.image051}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >Step 2: Mark them on your computer</span>
                                </b>
                                <span  >
                                Mark the files using Microsoft Word or other software on your computer.
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >Step 3: Upload students’ scores 
                                </span>
                                </b>
                            </p>
                            <p  >
                                
                                <span  >On the assignment submission page, click the‘Tools’ tab. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Select‘Upload student scores’ from the first pull-down list, and then select the assignment code and tutorial group. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Click the‘Download Excel’ button to download a template. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Fill in the Excel template as required. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Select the file to be uploaded and click‘Upload &amp; Verify’. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Review the preview of all data from your Excel file. Check all rows and click ‘Update Changes’. (Do <i >not</i> click‘Confirm and Submit’.) <br/>
                                </span>
                                <span >
                                
                                <a href={Image.Word.image053} data-lightbox="image053">                     
                                <img border={0} width={650} height={'auto'} src={Image.Word.image053}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >
                                    
                                </span>
                                </b>
                            </p>
                            <p >
                                <b >
                                <span  >Step 4: Upload students’ assignment files 
                                </span>
                                </b>
                            </p>
                            <p  >
                                
                                <span  >On the assignment submission page, click the‘Tools’ tab. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Select ‘Upload marked files’ from the first pull-down list, and then select the assignment code and tutorial group. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Drag all your marked files, or the folder containing the marked files, to the‘Drop file(s)’ area. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Check the rows of matched records and click‘Upload files’. <br/>
                                </span>
                                <span >
                                
                                <a href={Image.Word.image055} data-lightbox="image055">   
                                <img border={0} width={650} height={'auto'} src={Image.Word.image055}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <span  >
                                
                                </span>
                            </p>
                            <p >
                                <b >
                                <span  >Step 5: Confirm and submit 
                                </span>
                                </b>
                            </p>
                            <p  >
                                
                                <span  >On the assignment submission page, click the‘Tools’ tab. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Select ‘Upload student scores’ from the first pull-down list, and then select the assignment code and tutorial group. 
                                </span>
                            </p>
                            <p  >
                                
                                <span  >Review all rows and click‘Confirm and Submit’. <br/>
                                </span>
                                <span >
                                
                                <a href={Image.Word.image057} data-lightbox="image057">   
                                <img border={0} width={650} height={'auto'} src={Image.Word.image057}/>
                                </a>
                                
                                </span>
                                <span  >
                                
                                </span>
                            </p>
                        </div>
                    </div>
                    <NavBtn prevItem='/taking-attendance' nextItem='/zoom-recording'/>
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default CoursePage;
export default connect(mapStateToProps)(Assignments);